// Assets
import blank from "assets/images/blank_canvas.svg"

// Components
import { ActionButton } from "components"

// Icons
import { AiOutlineHome } from "react-icons/ai"

// Third-Party Library
import { useNavigate } from "react-router-dom"

// Config
import { logo } from "Config"

const PageNotFound = () => {
  // Hooks
  const navigate = useNavigate()

  return (
    <div className="position-relative" style={{ height: '100vh' }}>
      <div className="position-absolute top-50 start-50 translate-middle text-center d-flex flex-column">
        <section className="mb-5 text-center">
          <img alt="Logo" src={logo} height="80" />
          <h3 className="fw-bolder">404 - Page Not Found</h3>
          <ActionButton color="primary" className="text-white" onClick={() => navigate("/")}>
            <AiOutlineHome /> Home
          </ActionButton>
        </section>

        <img alt="Page Not Found" src={blank} className="img-fluid" />
      </div>
    </div>
  )
}

export default PageNotFound